import {IFormProps} from "../../component/form/model/FormModel";
import {LocateCountryDataChoice} from "../../../ts/data/locate/LocateCountryDataFactory";
import BasicForm from "../../component/form/BasicForm";
import ApiResponseVO from "../../../ts/manager/api/ApiResonseVO";
import {getModelFactory} from "../../../ts/model-factory/ModelFactory";
import ApiError from "../../../ts/manager/api/ApiError";
import {IonItem, IonList, IonSelectOption} from "@ionic/react";
import SelectFIE from "../../component/form/form-item-element/SelectFIE";
import {PostType} from "../../../ts/manager/post/PostManager";

interface IProps extends IFormProps
{
    postType:PostType|null;
    countryChoiceList:LocateCountryDataChoice[];

    countryCode?:string;

    onSearchSubmit: (countryCode:string) => void;
}

export default class LocateMapForm extends BasicForm
{
    props: IProps;

    countryCode:string;

    constructor(props: IProps)
    {
        super(props);

        this.props = props;

        this.countryCode = props.countryCode ?? "";
    }

    async handleSubmitItems(formItemIDs: string[]|null): Promise<ApiResponseVO>
    {
        const params = this.collectParams(formItemIDs);
        this.countryCode = params.country_code ?? "";
        const locateModel = getModelFactory().locateData.getMapLocateDataModel(
            this.props.postType,
            this.countryCode,
        );
        const responseVO = new ApiResponseVO();
        return locateModel.requirePopulated().then(() => {
            return responseVO;
        }).catch((error:ApiError) => {
            responseVO.apiError = error;
            return responseVO;
        });
    }

    handleSubmitComplete()
    {
        this.props.onSearchSubmit(this.countryCode);
    }

    renderComponent()
    {

        return <>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <form
                            className={"custom-form "+(this.isDisabled() ? "content-disabled" : "")}
                        >

                            {this.formAlerts()}
                            {this.requiredFieldsMessage()}
                            <IonList>
                                <IonItem>
                                    <SelectFIE
                                        form={this}
                                        formItemProps={{
                                            pointer: "country_code",
                                            name: "Country",
                                            value: this.countryCode,
                                            required: true,
                                            errorMessages: {
                                                required: "Please select a county"
                                            }
                                        }}
                                        onItemChange={this.handleChangeItemSubmit}
                                    >
                                        {this.props.countryChoiceList.map((choice) =>
                                        {
                                            return <IonSelectOption
                                                key={choice.id}
                                                value={choice.id}
                                            >
                                                {choice.name} ({choice.count})
                                            </IonSelectOption>
                                        })}
                                    </SelectFIE>
                                </IonItem>

                            </IonList>

                        </form>
                    </div>
                </div>
            </div>

        </>;
    }
}